package com.essntl.features.invoice.ui.addeditinvoice.components.sidebar

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceEvent
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceState
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceValidation
import com.essntl.features.invoice.ui.addeditinvoice.price.calcTotalPrice
import com.essntl.features.invoice.ui.rememberItineraryServicesPriceDetailsList
import com.essntl.features.invoice.ui.rememberProposalServicesPriceDetailsList
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.utils.EsModifiers.LargeSectionModifier
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun InvoicingTotalSection(
    state: AddEditInvoiceState,
    validation: AddEditInvoiceValidation,
    onEvent: (AddEditInvoiceEvent) -> Unit,
) {
    val itinerary = state.getItinerary.data

    val servicesPriceDetailsList =
        if (itinerary != null)
            rememberItineraryServicesPriceDetailsList(
                getAllItineraryServices = state.getAllItineraryServices,
                checkedServiceIds = state.checkedServiceIds,
            )
        else
            rememberProposalServicesPriceDetailsList(
                getAllProposalServices = state.getAllProposalServices,
                checkedServiceIds = state.checkedServiceIds,
            )

    val extraServicesPriceDetailsList = remember(
        state.checkedServiceIds,
        state.extraServiceList,
    ) {
        state.extraServiceList.data
            .orEmpty()
            .map { extraService ->
                PriceDetailsUiState(
                    title = extraService.service.title,
                    price = extraService.unitPrice ?: 0,
                    quantity = extraService.quantity ?: 1,
                )
            }
    }

    val totalAmount = remember(
        servicesPriceDetailsList,
        extraServicesPriceDetailsList,
    ) {
        calcTotalPrice(
            servicesPriceDetailsList = servicesPriceDetailsList,
            extraServicesPriceDetailsList = extraServicesPriceDetailsList,
        )
    }

    Column(
        modifier = LargeSectionModifier,
    ) {
        Text(
            text = if (!state.getInvoice.data?.id.isNullOrEmpty())
                "New Total" else
                "Total",
            style = MaterialTheme.esTypography.h3Bold24,
            color = MaterialTheme.esColorScheme.textPrimary,
        )

        Spacer(modifier = Modifier.height(2.spacing))

        InvoicingPriceDetails(
            title = "Services",
            priceDetailsList = servicesPriceDetailsList,
            modifier = Modifier.fillMaxWidth(),
        )

        Spacer(modifier = Modifier.height(3.spacing))

        if (extraServicesPriceDetailsList.isNotEmpty()) {
            InvoicingPriceDetails(
                title = "Extra services",
                priceDetailsList = extraServicesPriceDetailsList,
                modifier = Modifier.fillMaxWidth(),
            )

            Spacer(modifier = Modifier.height(3.spacing))
        }

        Spacer(modifier = Modifier.height(3.spacing))

        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            Text(
                text = "Total amount",
                style = MaterialTheme.esTypography.p2Regular14,
                color = MaterialTheme.esColorScheme.textPrimary,
            )

            Spacer(modifier = Modifier.weight(1f))

            Text(
                text = "$${formatIntMoney(totalAmount)}",
                style = MaterialTheme.esTypography.h3Bold24,
                color = MaterialTheme.esColorScheme.textPrimary,
            )
        }

        Spacer(modifier = Modifier.height(2.spacing))

        EsLargePrimaryButton(
            onClick = {
                onEvent(AddEditInvoiceEvent.CreateUpdateInvoice)
            },
            text = if (!state.getInvoice.data?.id.isNullOrEmpty())
                "Update invoice" else
                "Create invoice",
            enabled = validation.addEditInvoiceForm.isValid,
            loading = state.addEditInvoice.isLoading,
            modifier = Modifier.fillMaxWidth(),
        )
    }
}